import { Injectable, TemplateRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MenuActionDirective } from '../../common/eparcours-components/components/mise-en-page/page/page-base/directives/menu-action.directive';
import { PageAnchorDirective } from '../../common/eparcours-components/components/mise-en-page/page/page-base/directives/page-anchor.directive';
import { View360itemComponent } from '../../common/eparcours-components/components/mise-en-page/view360/view360item/view360item.component';

@Injectable({
  providedIn: 'root',
})
export class PageLayoutService {
  itemsChange: BehaviorSubject<PageAnchorDirective[]> = new BehaviorSubject<PageAnchorDirective[]>([]);
  private navbarRightItems: PageAnchorDirective[] = [];

  headerRight$ = new BehaviorSubject<TemplateRef<any>>(null);

  menuActions: MenuActionDirective[] = [];
  private routeSubscription: Subscription;
  pages: View360itemComponent[] = [];

  private _menuActif = new BehaviorSubject<string>(null);

  private _menuActionsChanged = new BehaviorSubject<MenuActionDirective[]>([]);

  get menuActionsChanged$() {
    return this._menuActionsChanged.asObservable();
  }
  pathSelected: string;

  menuActif$ = this._menuActif.pipe(
    map(menu => this.getPageConfig(menu)),
    filter(menu => menu != null),
  );

  updateMenu() {
    this._menuActionsChanged.next(this.menuActions);
  }

  get pageSelected(): View360itemComponent {
    return this.getPageConfig(this.pathSelected);
  }

  private extraireNomPageFromPath(path: string) {
    const pathParts = path.split(`/`);
    let pagePath = pathParts.pop();
    while (pagePath.match(/\d+/) && pathParts.length>0) {
      pagePath = pathParts.pop();
    }
    return pagePath;
  }

  constructor(route: ActivatedRoute, router: Router) {
    this.routeSubscription = router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const path = this.extraireNomPageFromPath(router.url);
      this.pathSelected = path;
      this._menuActif.next(path);
    });
  }

  addMenuAction(menuAction: MenuActionDirective) {
    this.menuActions.push(menuAction);
    this._menuActionsChanged.next(this.menuActions);
  }

  removeMenuAction(menuAction: MenuActionDirective) {
    if (this.menuActions.indexOf(menuAction) >= 0) {
      this.menuActions.splice(this.menuActions.indexOf(menuAction), 1);
      this._menuActionsChanged.next(this.menuActions);
    }
  }

  addPageConfig(item: View360itemComponent) {
    if (!this.pages.find(it => it.path == item.path) && item.path != null) {
      this.pages.push(item);
      this.pages.sort((a, b) => a.ordre - b.ordre);
      if (this._menuActif.value == item.path) {
        this._menuActif.next(this.pathSelected);
      }
    }
  }

  getPageConfig(path: string): View360itemComponent {
    let cleanedPath = null;
    if (path != null) {
      cleanedPath = path.replace(/\/\d+$/, '');
    }
    return this.pages.find(it => it.path == cleanedPath);
  }

  set headerRightRef(value: TemplateRef<any>) {
    this.headerRight$.next(value);
  }

  clearNavbarRight(): void {
    this.navbarRightItems = [];
    this.onItemsChange();
  }

  clearMenus() {
    this.pages = [];
  }

  addItem(item: PageAnchorDirective) {
    this.navbarRightItems.push(item);
    this.onItemsChange();
  }

  private onItemsChange(): void {
    this.itemsChange.next(this.navbarRightItems);
  }
}
